import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { AddEditOwnDriver, AddEditVehicleModal, EbillExtentionModal, EndTripModal, UpdateMaintenanceStatus, VehicleDetailsModal } from 'modals';
import { changeVehicleStatusData, deleteVehicleData, getVehicleDetails, getVehicleListData, updateVehiclePlanningStatus } from '_services/accountsServices/vehicleServices';
import { Link, useNavigate } from 'react-router-dom';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { UserContext } from 'context';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import MastersFilterModal from 'modals/MastersFilterModal';
import AddEditSupplier from 'modals/AddEditSupplier';
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { actionPermission } from 'helper';
import { constant } from 'constants';
import { hasPermission } from 'utils/permissionHelper';
import { getLastTrip } from '_services';

const Vehicle = () => {
    useDocumentTitle("Fleet | T360");
    const navigate = useNavigate();
    const loadingBarRef = useRef(null);
    const prevFilterRef = useRef();

    const { masterData, truckChild, mastersChild, setMasterDetailsList, allMenu } = useContext(UserContext)
    const masterChildTrucks = truckChild?.find((i) => i?.label === "Fleets");
    const [showOffcanvasOfSupplier, setShowOffcanvasOfSupplier] = useState(false);
    const [showOffcanvasOfVehical, setShowOffcanvasOfVehical] = useState(false);

    const [showVehicleDetails, setShowVehicleDetails] = useState(false);

    const [vehicleStatusModal, setVehicleStatusModal] = useState({});
    const [showEndTrip, setShowEndTrip] = useState(false);
    const [lastLoading, setLastLoading] = useState({});
    const [lastTripDetails, setLastTripDetails] = useState();

    const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);

    const [isSupplier, setIsSupplier] = useState(false);
    const [isDriver, setIsDriver] = useState(false);

    const [vehicleList, setVehicleList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const [vehicleFirm, setVehicleFirm] = useState({});

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        // search: '',
        // status: 1
        vehicle_ownership: 0,
        vehicle_status: 0,
        search: "",
    });

    const [editVehicleData, setEditVehicleData] = useState(null)
    const [checkboxStates, setCheckboxStates] = useState({});
    const [filterCount, setFilterCount] = useState(0);
    const toggleOffcanvas = () => {
        setShowOffcanvasOfVehical(!showOffcanvasOfVehical);
        setEditVehicleData(null)
    };

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });



    useEffect(() => {
        const filteredValues = Object.entries(filter)
            .filter(
                ([key, val]) =>
                    key !== "offset" &&
                    key !== "limit" &&
                    key !== "company_id" &&
                    val !== "" &&
                    val !== null &&
                    val !== undefined &&
                    val !== 0
            )
            .map(([_, val]) => val);

        setFilterCount(filteredValues.length);

    }, [filter]);

    const getDataVehicleList = async () => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            const res = await getVehicleListData(object);
            if (res?.responseCode == 200) {
                setVehicleList(res?.data?.vehicle_list);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
            console.error('Error', error)
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDataVehicleList();
            prevFilterRef.current = filter;
        }
    }, [filter, showOffcanvasOfVehical]);

    useEffect(() => {
        setMasterDetailsList({})
    }, [])

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteVehicle = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: isDelete?.company_id,
                vehicle_id: isDelete?._id,
            }
            const res = await deleteVehicleData(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getDataVehicleList();
                setLoading(false);
                setIsDelete(false);
            } else {
                toast.success('Error !! ');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    // handling Add New Supplier button in Dropdown
    const handleAddNewSupplierButtonAction = (data) => {
        // setShowOffcanvasOfVehical(false);
        setIsSupplier(false);
        setShowOffcanvasOfSupplier(true);
        setVehicleFirm(data?.firm_id);
    }

    const handleAddNewVehicleButtonAction = (data) => {
        // setShowOffcanvasOfVehical(false);
        setIsDriver(false)
        setShowOffcanvasOfDriver(true);
        setVehicleFirm(data?.firm_id);
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteVehicle,
        isLoadding: loading,
    }

    const columns = [
        // { header: "", accessor: "serial" },
        { header: "Vehicle Number", accessor: "vehicle_no" },
        { header: "Firm", accessor: "firm_id" },
        { header: "Type", accessor: "type" },
        { header: "Ownership", accessor: "ownership" },
        { header: "Assoicated", accessor: "assoicated" },
        { header: "Vehicle Status", accessor: "vehicle_status" },
        { header: "Trip Status", accessor: "trip_status" },
        { header: "End Location", accessor: "endlocation" },
        { header: "Maintenance", accessor: "maintenance" },
        { header: "Status", accessor: "status" },
        { header: "Action", accessor: "action" }

    ];

    useEffect(() => {
        if (vehicleList && vehicleList.length > 0) {
            const initialStates = vehicleList.reduce((acc, item) => {
                acc[item._id] = Boolean(item?.active);
                return acc;
            }, {});
            setCheckboxStates(initialStates);
        }
    }, [vehicleList]);

    const ChangeVehicleStatus = async (obj) => {
        try {
            if (obj) {
                const res = await changeVehicleStatusData(obj);
                if (res?.responseCode === 200) {
                    toast.success(`${res?.responseMessage}`);
                    await getDataVehicleList();
                } else {
                    toast.error('Error !!');
                    await getDataVehicleList();
                }
            }
        } catch (error) {
            toast.error(error.message);
            await getDataVehicleList();
        }
    };

    const handleCheckboxChange = (id) => {
        const newStatus = !checkboxStates[id];
        setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

        const object = {
            company_id: StorageService.getCompanyId(),
            vehicle_id: id,
            active: Number(newStatus)
        };
        ChangeVehicleStatus(object);
    };

    const callBackEndForList = (response) => {
        console.log('response', response?.vehicle_id)
        setVehicleStatusModal(response?.vehicle_id)
    }

    const getLastTripdetails = async (data) => {
        setLastLoading(true);
        const vehicleId = data?._id;

        setLastLoading((prev) => ({ ...prev, [vehicleId]: true }));
        const res = await getLastTrip({
            company_id: StorageService.getCompanyId(),
            vehicle_id: data?._id,
        });
        if (res?.responseCode === 200) {
            setLastLoading((prev) => ({ ...prev, [vehicleId]: false }));
            setLastTripDetails(res.data?.trip);
            setShowEndTrip(res.data?.trip);
        } else {
            setLastLoading((prev) => ({ ...prev, [vehicleId]: false }));
            toast.error(res?.responseMessage);
        }
    };

    const statusChangeofvehicle = async (obj) => {
        try {
            if (obj) {
                const res = await updateVehiclePlanningStatus(obj);
                if (res?.responseCode === 200) {
                    toast.success(`${res?.responseMessage ? res?.responseMessage : 'Updated Successfully'} `);
                    getDataVehicleList();
                } else {
                    toast.error('Error !!');
                }
            }
        } catch (error) {
            toast.error(error.message);
            await getDataVehicleList();
        }
    };

    const vehicleStatusChanges = (item) => {
        if (item?.vehicle_status === 1) {
            setVehicleStatusModal({ ...item, vehicle_id: item?._id })
        }
        if (item?.vehicle_status === 2) {
            getLastTripdetails(item);
        }
        if (item?.vehicle_status === 3) {
            const object = {
                company_id: StorageService.getCompanyId(),
                vehicle_id: item?._id,
                vehicle_status: 1,
                updated_available_date: new Date(),
            };
            statusChangeofvehicle(object);
        }
    };

    const getSingleVehicleData = async (vehicle_id) => {
        // setLoading(true);
        try {
            let object = {
                vehicle_id: vehicle_id,
            }
            const res = await getVehicleDetails(object);
            if (res?.responseCode == 200) {
                setLoading(false);
                setShowOffcanvasOfVehical(res?.data?.vehicle)
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    const editHandler = (data) => {
        getSingleVehicleData(data?._id);
    };

    const handleClick = (event) => {
        event.stopPropagation();
    };

    const onRowClick = (e, item) => {
        navigate(`details/${item?._id}?type=${constant.m_type.vehicle}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&vehicle_no=${item?.vehicle_no}`)
        setMasterDetailsList((s) => ({ ...s, list: vehicleList, details: item }))
    }

    const RowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
            serial: <>
                <div className="signDropdown">
                    <button className="dropbtn11">
                        <BsThreeDotsVertical />
                    </button>
                    <div className="dropdownContent">
                        {masterChildTrucks?.view === 1 &&
                            <div onClick={(e) => setShowVehicleDetails(item)} className='_avPointer'
                                style={{ textDecoration: 'none' }}
                            >
                                <span className='_samAnchor'>
                                    <span className='viewIcon_avt'>
                                        <AiOutlineEye />
                                    </span>View
                                </span>
                            </div>}

                        {masterChildTrucks?.edit === 1 && <div
                            onClick={(e) => editHandler(item)}
                            className='_avPointer'
                        >
                            <span className='_samAnchor'>
                                <span className='editIcon_avt'>
                                    <FiEdit />
                                </span>
                                Edit
                            </span>
                        </div>}

                        {masterChildTrucks?.delete === 1 && <div
                            onClick={(e) => deleteHandler(item)}
                            className='_avPointer'
                        >
                            <span className='_samAnchor'>
                                <span className='deleteIcon_avt'>
                                    <FaRegTrashCan color='red' />
                                </span>
                                Delete
                            </span>
                        </div>}
                    </div>
                </div>
            </>,
            vehicle_no:
                <Link
                    to={`details/${item?._id}?type=${constant.m_type.vehicle}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&vehicle_no=${item?.vehicle_no}`}
                    style={{ textDecoration: 'none' }}
                    onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: vehicleList, details: item })) }}
                >
                    {item?.vehicle_no ? item?.vehicle_no : '-'}
                </Link>,
            firm_id: <React.Fragment>
                {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
            </React.Fragment>,
            type:
                <React.Fragment>
                    {item?.lorry_type_id?.lorry_type ? item?.lorry_type_id?.lorry_type : '-'} {`> `}
                    {item?.vehicle_type_id_1?.name ? item?.vehicle_type_id_1?.name : '-'}
                </React.Fragment>,
            ownership:
                <React.Fragment>
                    {masterData?.vehicle_ownership[item?.vehicle_ownership]}
                </React.Fragment>,
            assoicated:
                <React.Fragment>
                    {item?.city?.label ? item?.city?.label : '-'}
                </React.Fragment>,
            vehicle_status:
                <React.Fragment>
                    {masterData?.vehicle_status[item?.vehicle_status]}
                </React.Fragment>,
            trip_status:
                <React.Fragment>
                    <span
                        className={
                            masterData?.trip_status[item?.trip_id?.trip_status] === "Pending"
                                ? "_lrPending_status"
                                : masterData?.trip_status[item?.trip_id?.trip_status] === "In Transit"
                                    ? "_lrInTransit_status"
                                    : masterData?.trip_status[item?.trip_id?.trip_status] === "At Party Point"
                                        ? "_lrPartyPoint_status"
                                        : masterData?.trip_status[item?.trip_id?.trip_status] === "Delivered"
                                            ? "_lrDelivered_status"
                                            : masterData?.trip_status[item?.trip_id?.trip_status] === "Bill Raised"
                                                ? "_lrDelivered_status"
                                                : masterData?.trip_status[item?.trip_id?.trip_status] === "Cancelled"
                                                    ? "_lrCanceled_status"
                                                    : ""
                        }
                    >
                        {masterData?.trip_status[item?.trip_id?.trip_status]}
                    </span>
                </React.Fragment>,
            status: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="actStatus"
                        id={`actStatus-${item._id}`}
                        autoComplete="off"
                        checked={checkboxStates[item._id]}
                        onChange={() => handleCheckboxChange(item._id)}
                    />
                    <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
                        {checkboxStates[item._id] ? "Active" : "Disabled"}
                    </span>
                </div>
            ),
            maintenance: (item?.vehicle_ownership != 2 &&
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="vehicleStatus"
                        id={`vehicleStatus-${item._id}`}
                        autoComplete="off"
                        checked={Number(item?.vehicle_status) === 3}
                        onChange={() => item?.active && vehicleStatusChanges(item)}
                    />
                </div>
            ),

            endlocation: (
                <>
                    {[item?.end_location?.to_city, item?.end_location?.to_state].filter(Boolean).join(", ")}
                </>
            ),

            action: (
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "100px" }}
                >
                    {masterChildTrucks?.view === 1 &&
                        <div onClick={(e) => { handleClick(e); setShowVehicleDetails(item) }} className='_avPointer'
                            style={{ textDecoration: 'none' }}
                        >
                            <span className='_samAnchor'>
                                <span className='viewIcon_avt'>
                                    <AiOutlineEye color='green' />
                                </span>
                            </span>
                        </div>}

                    {masterChildTrucks?.edit === 1 && <div
                        onClick={(e) => { handleClick(e); editHandler(item) }}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color='blue' />
                            </span>

                        </span>
                    </div>}

                    {masterChildTrucks?.delete === 1 && <div
                        onClick={(e) => { handleClick(e); deleteHandler(item) }}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='deleteIcon_avt'>
                                <FaRegTrashCan color='red' />
                            </span>

                        </span>
                    </div>}

                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };


    const handleSupplierNextModal = () => {
        setIsSupplier(!isSupplier)
        setShowOffcanvasOfVehical(true)
    }

    const handleDriverNextModal = () => {
        setIsDriver(!isDriver)
        setShowOffcanvasOfVehical(true)
    }


    const clearFilter = () => {
        setFilter((pre) => ({
            ...pre,
            vehicle_ownership: 0,
            vehicle_status: 0,
            search: "",
            limit: 25,
            offset: 1,

        }));

        setFilterCount(0);
    };


    const handlePermissionCallVehcile = async () => {
        // e.preventDefault();

        await actionPermission({
            company_id: StorageService.getCompanyId(),
            type: constant?.USABILITY_CONFIG_TYPES?.FETCH_VEHICLE_DOCUMENT,
            onSuccess: () => { },
            setModalConfig, // Pass setter
        });
    };

    const callBackVehicle = (data) => {
        console.log("callBackVehicle", data)
        if (data?.is_template_open) {
            handlePermissionCallVehcile()
        }
    }

    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    let vehicleStatusDataModal = {
        isOpen: vehicleStatusModal,
        closeModal: (e) => setVehicleStatusModal({}),
        modalMainClass: " _dashCommon_Modal  _mdModal __updateListModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: "Update Status",
        submitTitle: "Update Status",
        callListApi: (e) => getDataVehicleList(e),
    };

    let endTripModal = {
        isOpen: showEndTrip,
        closeModal: (e) => {
            setShowEndTrip(false);
        },
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "End Previous Trip",
        submitTitle: "End Trip",
        callBackEndForList: (data) => callBackEndForList(data),
        lastTripDetails: lastTripDetails,
    };

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={"Vehicle"}
                onClick={toggleOffcanvas}
                buttonTitle={masterChildTrucks?.create === 1 && "Add Vehicle"}
                showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                filterCount={filterCount}
                clearFilter={clearFilter}
                isDebouncedSearch={true}
            />

            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    data={RowListData(vehicleList?.length > 0 ? vehicleList : [])}
                    isLoading={loading}
                    onRowClick={(e, row) => {
                        if (e.target.closest(".no-row-click")) return; // ignore protected cells
                        onRowClick(e, row);
                    }}
                />

                {vehicleList?.length > 0 && <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div>}
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfVehical ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasOfVehical ? 'visible' : 'hidden' }}
            >
                {showOffcanvasOfVehical &&
                    <AddEditVehicleModal
                        isOpen={showOffcanvasOfVehical}
                        onClose={() => { setShowOffcanvasOfVehical(false); setIsSupplier(false); setIsDriver(false); getDataVehicleList(); }}
                        isSupplier={isSupplier}
                        isDriver={isDriver}
                        handleAddNewSupplierButtonAction={handleAddNewSupplierButtonAction}
                        handleAddNewVehicleButtonAction={handleAddNewVehicleButtonAction}
                        callBackVehicleFleet={callBackVehicle}
                    />
                }
            </div>

            <div className={showOffcanvasOfVehical ? 'offBack_drop' : ''}></div>

            {/* Supplier Canvas Open and Vahicle canvas will close */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfSupplier ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasOfSupplier ? 'visible' : 'hidden' }}
            >
                {showOffcanvasOfSupplier &&
                    <AddEditSupplier
                        isOpen={showOffcanvasOfSupplier}
                        onClose={(e) => setShowOffcanvasOfSupplier(false)}
                        callBackSupplier={(e) => handleSupplierNextModal(e)}
                        branchFirmId={vehicleFirm}
                        hideAddNewOption={false}
                    />
                }
            </div>
            <div className={showOffcanvasOfSupplier ? 'offBack_drop' : ''}></div>

            {/* Driver Canvas Open and Vahicle canvas will close */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasOfDriver ? 'visible' : 'hidden' }}
            >
                {showOffcanvasOfDriver &&
                    <AddEditOwnDriver
                        isOpen={showOffcanvasOfDriver}
                        onClose={() => setShowOffcanvasOfDriver(false)}
                        callBackDriver={(e) => handleDriverNextModal(e)}
                        vehicleFirmId={vehicleFirm}
                        hideAddNewOption={false}
                    />
                }
            </div>
            <div className={showOffcanvasOfDriver ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
            >
                {showFilterModal &&
                    <MastersFilterModal
                        isOpen={showFilterModal}
                        onClose={() => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={{
                            // driver: true,
                            ownership: true,
                            vehicle_status: true,
                            search: false
                        }}
                        list={{

                            // supplier: listData?.supplierList,
                            // driver: listData?.driverList,
                            // vehicle:listData?.vehicleList
                        }}
                        setFilterCount={setFilterCount}
                        filterCount={filterCount}
                        name="Vehicle"
                    />
                }
            </div>
            <div className={showFilterModal ? 'offBack_drop' : ''}></div>

            {/* vehicle details modal start */}

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showVehicleDetails ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showVehicleDetails ? 'visible' : 'hidden' }}
            >
                {showVehicleDetails &&
                    <VehicleDetailsModal
                        isOpen={showVehicleDetails}
                        onClose={() => setShowVehicleDetails(false)}
                        isSupplier={isSupplier}
                        isDriver={isDriver}
                        handleAddNewSupplierButtonAction={handleAddNewSupplierButtonAction}
                        handleAddNewVehicleButtonAction={handleAddNewVehicleButtonAction}
                    />
                }
            </div>

            <div className={showVehicleDetails ? 'offBack_drop' : ''}></div>

            {/* vehicle details model end */}

            {
                isDelete?.company_id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }

            {modalConfig.isOpen && <EbillExtentionModal
                {...ebillExpProps}
            />}

            {vehicleStatusModal?._id && <UpdateMaintenanceStatus {...vehicleStatusDataModal} />}

            {showEndTrip && <EndTripModal {...endTripModal} />}
        </div>
    )
}

export default Vehicle